import clsx from 'clsx'

import { AppTestIds } from '../../../../app/constants'
import { ProfileMenuSection } from '../../../types'

import styles from './ProfileMenuSections.module.scss'

type ProfileMenuSectionsProps = {
  sections: ProfileMenuSection[]
  /** Runs after an item is selected, e.g. to close the menu */
  onItemSelected?: () => void
}

export default function ProfileMenuSections({
  sections,
  onItemSelected,
}: ProfileMenuSectionsProps) {
  return (
    <>
      {sections.map(({ id, label, items }) => (
        <div key={id} className={styles.section}>
          {label && <div className={styles.label}>{label}</div>}
          <ul className={styles.items}>
            {items.map(item => (
              <li key={item.id}>
                <button
                  type="button"
                  className={clsx(styles.item, {
                    [styles.danger]: item.isDanger,
                  })}
                  disabled={item.disabled}
                  data-testid={AppTestIds.NavBar.Dropdown.Option + item.id}
                  onClick={async () => {
                    if (item.closesOnSuccess) {
                      if ((await item.onSelect()) === true) {
                        onItemSelected?.()
                      }
                      return
                    }

                    item.onSelect()
                    onItemSelected?.()
                  }}
                >
                  {item.Icon && (
                    <item.Icon aria-hidden className={styles.icon} />
                  )}
                  <span className={styles.text}>
                    <span>{item.label}</span>
                    {item.description && (
                      <span className={styles.description}>
                        {item.description}
                      </span>
                    )}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  )
}
